import apiHandler from "../core/apiHandler";

const notificationsApi = apiHandler('notifications');
export default notificationsApi;
